$(document).ready(function(){

  if( $('.template-cart').length > 0){

    updateCart = function(){
      $('form.cart').submit();
    }

    $('body').on('change', '.js-qty input', function(){
      updateCart();
    });

    checkForZeroQuantity = function(element){
      if($(element).find('input').val() == '0'){
        updateCart();
      }
    }

    $('body').on('quantityButtonClicked', "td[data-label='Quantity']", function(){
      setTimeout(checkForZeroQuantity, 200, this);
    });

    $('body').on('click', '.js-qty__adjust--minus', function(){
      $(this).trigger('quantityButtonClicked');
    });


  }

});
